import { observer } from "mobx-react";
import { __, _i } from "../../utils";
import { List, Space, Spin, message } from "antd";
import { ClockCircleOutlined, CloudServerOutlined, CloudUploadOutlined } from "@ant-design/icons";
import { PluginUpdateLicenseTelemetryDataModal } from ".";
const PluginUpdateLicenseListItem = observer(({
  license,
  onDeactivate
}) => {
  const {
    busy,
    installationType,
    telemetryDataSharingOptIn,
    blogName,
    code,
    remote,
    programmatically,
    host,
    blog,
    store: {
      needsLicenseKeys
    }
  } = license;
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: busy
  }, /*#__PURE__*/React.createElement(List.Item, {
    style: {
      paddingLeft: 0,
      paddingRight: 0
    },
    actions: [needsLicenseKeys && /*#__PURE__*/React.createElement(Space, {
      key: "installationType"
    }, /*#__PURE__*/React.createElement(CloudServerOutlined, null), installationType === "production" ? __("Production") : installationType === "development" ? __("Development") : "n/a"), remote && /*#__PURE__*/React.createElement(Space, {
      key: "activatedAt"
    }, /*#__PURE__*/React.createElement(ClockCircleOutlined, null), __("Activated %s", new Date(remote.licenseActivation.activatedAt).toLocaleString(document.documentElement.lang))), /*#__PURE__*/React.createElement(PluginUpdateLicenseTelemetryDataModal, {
      key: "telemetryModal",
      license: license,
      disabled: !telemetryDataSharingOptIn
    }, /*#__PURE__*/React.createElement(Space, {
      key: "telemetryDataSharingOptIn",
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(CloudUploadOutlined, null), telemetryDataSharingOptIn ? __("Telemetry data sharing enabled") : __("Telemetry data sharing disabled"))), !programmatically && /*#__PURE__*/React.createElement("a", {
      key: "deactivate",
      className: "button-link",
      onClick: async () => {
        try {
          await license.deactivate();
        } catch (e) {
          message.error(e.responseJSON.message);
        }

        onDeactivate === null || onDeactivate === void 0 ? void 0 : onDeactivate(license);
      }
    }, __("Deactivate"))].filter(Boolean)
  }, /*#__PURE__*/React.createElement(List.Item.Meta, {
    title: blogName,
    description: needsLicenseKeys ? /*#__PURE__*/React.createElement(React.Fragment, null, __("Your license key"), ": ", /*#__PURE__*/React.createElement("code", null, code)) : /*#__PURE__*/React.createElement(React.Fragment, null, __("Your installation is fully activated."), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 15
      }
    }, /*#__PURE__*/React.createElement("a", {
      rel: "noreferrer",
      href: __("https://devowl.io/knowledge-base/real-cookie-banner-upgrade-free-to-pro-version/"),
      className: "button",
      target: "_blank"
    }, __("Enter license key to unlock PRO features"))))
  }), programmatically && /*#__PURE__*/React.createElement("div", {
    className: "notice notice-info inline below-h2 notice-alt",
    style: {
      margin: "0 0 10px 0"
    }
  }, /*#__PURE__*/React.createElement("p", null, _i(__("This license cannot be deactivated manually because it is configured programmatically. That means you have used the {{a}}activation filter{{/a}} for host {{code}}%s{{/code}} (Blog ID: %d). Please remove the filter to deactivate the license!", host, blog), {
    code: /*#__PURE__*/React.createElement("code", null),
    a: /*#__PURE__*/React.createElement("a", {
      href: "https://docs.devowl.io/real-cookie-banner/hooks/DevOwl_RealProductManager_License_Programmatic_$slug.html",
      target: "_blank",
      rel: "noreferrer"
    })
  })))));
});
export { PluginUpdateLicenseListItem };